(function(){

function initCountdown(id){

const sec=document.getElementById("cd-"+id);
if(!sec)return;

const timer=sec.querySelector(".cd-tmr");
if(!timer)return;


const mode=timer.dataset.mode;
const custom=timer.dataset.end;


const d=timer.querySelector('[data-u="d"]');
const h=timer.querySelector('[data-u="h"]');
const m=timer.querySelector('[data-u="m"]');
const s=timer.querySelector('[data-u="s"]');


function pad(v){
return v<10?"0"+v:v;
}


function weeklyEnd(){

let now=new Date();
let day=now.getDay();

let end=new Date(now);

let friday=(5-day+7)%7;

if(day===6){
friday=6;
}

end.setDate(now.getDate()+friday);
end.setHours(23,59,59,999);

return end.getTime();

}


function getEnd(){

if(mode==="custom"){

let t=new Date(custom.replace(" ","T")).getTime();

if(!isNaN(t)) return t;

}

return weeklyEnd();

}


function update(){

let diff=getEnd()-Date.now();

if(diff<0) diff=0;


let total=Math.floor(diff/1000);

d.textContent=pad(Math.floor(total/86400));

h.textContent=pad(Math.floor(total%86400/3600));

m.textContent=pad(Math.floor(total%3600/60));

s.textContent=pad(total%60);

}


update();

setInterval(update,1000);

}


function boot(){

document.querySelectorAll("[data-section-type='countdown-timer']")
.forEach(el=>{
initCountdown(el.dataset.sectionId);
});

}


document.addEventListener("DOMContentLoaded",boot);

document.addEventListener("shopify:section:load",boot);

})();
